import React, { useMemo, useState } from 'react'
import { Form, Input, Label, Segment } from 'semantic-ui-react'
import { Live } from '../../api/services/next'
import { DatePicker } from '../../components/shared/DatePicker'
import HotelsDropDown from '../../components/shared/HotelsDropDown'
import { useTextResources } from '../../language'
import GridSearchTemplate from '../GridSearchTemplate'
import moment from 'moment'
import _ from 'lodash'
import { isMobileOnly } from 'mobile-device-detect';
import RoomTypesDropDown from '../../components/shared/RoomTypesDropDown'
import RatesDropDown from '../../components/shared/RatesDropDown'
import { RateCategory } from '../../components/shared/constants';
import { Currencies } from '../../components/shared/currencies';


export const LivePage = () => {
  const text = useTextResources()
  const levels = ['HotelName', 'RoomTypeName', 'RateName', 'ProductName']
  const titles = [text('Hotel'), text('RoomType'), text('Rate')]
  const days = 10

  const [search, setSearch] = useState({
    FromDate: moment().toDate()
  })
  const onSearchChange = search => {
    setSearch(search)
  }

  const fmt = "dd DD/MM";
  const date_x = x => moment(search.FromDate).add(x, 'day').format(fmt)

  const liveDataFormatter = ({ value, row }) => {
    const productFormatters = {
      // Per Room
      1: <Segment key="Product-PerRoom" size="mini" style={{ paddingTop: "1em", paddingBottom: "1em" }} secondary>
        <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
          <div style={{ flex: 1, paddingBottom: "1em" }}>
            <Input value={value.RoomPrice} size="small" labelPosition='right' type='text' placeholder={text("Room")} fluid>
              <Label>R</Label>
              <input />
              <Label basic>{Currencies[row.CurrencyId || 0].symbol}</Label>
            </Input>
          </div>
        </div>
      </Segment>,
      // Per Person
      2: <Segment key="Product-PerPerson" size="mini" style={{ paddingTop: "1em", paddingBottom: "1em" }} secondary>
        <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
          <div style={{ flex: 1, paddingBottom: "1em" }}>
            <Input size="small" labelPosition='right' type='text' placeholder={text("Single")} fluid>
              <Label>S</Label>
              <input />
              <Label basic>{Currencies[row.CurrencyId || 0].symbol}</Label>
            </Input>
          </div>
          <div style={{ flex: 1 }}>
            <Input size="small" labelPosition='right' type='text' placeholder={text("Double")} fluid>
              <Label>D</Label>
              <input />
              <Label basic>{Currencies[row.CurrencyId || 0].symbol}</Label>
            </Input>
          </div>
        </div>
      </Segment>,
      // Per Combination
      3: <Segment key="Product-PerCombination" size="mini" style={{ paddingTop: "1em", paddingBottom: "1em" }} secondary>
        <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
          <div style={{ flex: 1, paddingBottom: "1em" }}>
            <Input size="small" labelPosition='right' type='text' placeholder={text("Single")} fluid>
              <Label>S</Label>
              <input />
              <Label basic>{Currencies[row.CurrencyId || 0].symbol}</Label>
            </Input>
          </div>
          <div style={{ flex: 1 }}>
            <Input size="small" labelPosition='right' type='text' placeholder={text("Double")} fluid>
              <Label>D</Label>
              <input />
              <Label basic>{Currencies[row.CurrencyId || 0].symbol}</Label>
            </Input>
          </div>
        </div>
      </Segment>,
      // Villa
      4: <Segment key="Product-Villa" size="mini" style={{ paddingTop: "1em", paddingBottom: "1em" }} secondary>
        <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
          <div style={{ flex: 1, paddingBottom: "1em" }}>
            <Label>{text("Guests")}: {row.Guests}</Label>
          </div>
          <div style={{ flex: 1 }}>
            <Input size="small" labelPosition='right' type='text' placeholder={text("Villa")} fluid>
              <Label>V</Label>
              <input />
              <Label basic>{Currencies[row.CurrencyId || 0].symbol}</Label>
            </Input>
          </div>
        </div>
      </Segment>
    }
    const formatters = [
      // Hotel
      <Segment key="Hotel" size="mini" style={{ paddingTop: "2em", paddingBottom: "4em" }} secondary>
        <Label color={value?.Available > 0 ? 'teal' : value?.Available < 0 ? 'red' : 'blue'} floating circular style={{ left: "1em" }}>
          {value?.Available || 0}
        </Label>
        <Label attached='bottom left' basic>
          {(((value?.Sold || 0) / (value?.Gross || 1)) * 100).toFixed(0)}%
        </Label>
        <Label attached='bottom right' basic>
          Y={(value?.Yield || 0).toFixed(0)}
        </Label>
        <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
          <div style={{ flex: 0.5 }}>
            <Input size="small" placeholder={text("Min")} fluid />
          </div>
          <div style={{ width: 5 }}></div>
          <div style={{ flex: 0.5 }}>
            <Input size="small" placeholder={text("Max")} fluid />
          </div>
        </div>
      </Segment>,
      // Room type
      <Segment key="Roomtype" size="mini" style={{ paddingTop: "2em", paddingBottom: "4em" }} secondary>
        <Label color={value?.Available > 0 ? 'teal' : value?.Available < 0 ? 'red' : 'blue'} floating circular style={{ left: "1em" }}>
          {value?.Available || 0}
        </Label>
        <Label attached='bottom left' basic>
          {(((value?.Sold || 0) / (value?.Gross || 1)) * 100).toFixed(0)}%
        </Label>
        <Label attached='bottom right' basic>
          Y={(value?.Yield || 0).toFixed(0)}
        </Label>
        <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
          <div style={{ flex: 0.5 }}>
            <Input size="small" placeholder={text("Min")} fluid />
          </div>
          <div style={{ width: 5 }}></div>
          <div style={{ flex: 0.5 }}>
            <Input size="small" placeholder={text("Max")} fluid />
          </div>
        </div>
      </Segment>,
      // Rate
      <Segment key="Rate" size="mini" style={{ paddingTop: "1em", paddingBottom: "1em" }} secondary>
        <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
          <div style={{ flex: 0.5 }}>
            <Input size="small" placeholder={text("Min")} fluid />
          </div>
          <div style={{ width: 5 }}></div>
          <div style={{ flex: 0.5 }}>
            <Input size="small" placeholder={text("Max")} fluid />
          </div>
        </div>
      </Segment>,
      // Product
      productFormatters[row.RateType]
    ]
    return formatters[row.Level]
  }

  const RoomTypesSpec = React.useMemo(() => {
    return {
      ...search,
      FromDate: null,
      EndDate: null
    };
  }, [search]);

  const RatesSpec = React.useMemo(() => {
    return {
      ...search,
      IsActive: true,
      InheritedRates: true,
      FromDate: moment(search.FromDate).toISOString(),
      ToDate: moment(search.FromDate).add(days, "days").toISOString(),
      ExcludeRateCategoryIDs: [
        RateCategory.ExtraAddon,
        RateCategory.AgentPromotion,
      ]
    }
  }, [search]);

  const gridOptions = {
    search: {
      fields: [
        <Form.Field width={4} placeholder={text('All')} multiple clearable control={HotelsDropDown} label={text('Hotels')} key="HotelIDs" />,
        <DatePicker
          type="basic"
          label={text("StartDate")}
          name="FromDate"
          key="FromDate"
        />,
        <Form.Field label={text("RoomType")} key="RoomTypeId" placeholder={text('All')} clearable search control={RoomTypesDropDown} spec={RoomTypesSpec} />,
        <Form.Field label={text("Rate")} key="RateId" placeholder={text('All')} clearable search control={RatesDropDown} spec={RatesSpec} />
      ],
      initial: search,
      api: Live.GetLiveData
    },
    grid: {
      menu: {
        left: [],
        right: []
      },
      columns: useMemo(() => {
        let columns = [
          { name: 'Selection', title: text('Level') },
          { name: 'Date_0', title: date_x(0), formatter: liveDataFormatter },
          { name: 'Date_1', title: date_x(1), formatter: liveDataFormatter },
          { name: 'Date_2', title: date_x(2), formatter: liveDataFormatter },
          { name: 'Date_3', title: date_x(3), formatter: liveDataFormatter },
          { name: 'Date_4', title: date_x(4), formatter: liveDataFormatter },
          { name: 'Date_5', title: date_x(5), formatter: liveDataFormatter },
          { name: 'Date_6', title: date_x(6), formatter: liveDataFormatter },
          { name: 'Date_7', title: date_x(7), formatter: liveDataFormatter },
          { name: 'Date_8', title: date_x(8), formatter: liveDataFormatter },
          { name: 'Date_9', title: date_x(9), formatter: liveDataFormatter },
        ]
        return columns
      }, [search]),
      tree: {
        getChildRows: (row, rootRows) => {
          const group = (level, rows) => {
            const current = levels[level]
            if (current) {
              const grouped = _.groupBy(rows, current)
              const result = _.map(grouped, (children, group) => {
                let row = {
                  Selection: titles[level] ? `${titles[level]}: ${group}` : group,
                  RateType: children[0]?.RateType,
                  IsVillaRate: children[0]?.IsVillaRate,
                  CurrencyId: children[0]?.CurrencyId,
                  Guests: children[0]?.Guests,
                  Level: level,
                  next: level + 1,
                  children
                }
                for (let i = 0; i < days; i++) {
                  switch (level) {
                    case 0:
                    case 1:
                      row[`Date_${i}`] = {
                        Yield: level ? _.sumBy(children, `Dates[${i}].Yield`) : _.meanBy(children.filter(x => x.Dates[0].Yield), `Dates[${i}].Yield`) || 0,
                        Gross: _.sumBy(children, `Dates[${i}].Availability.Gross`),
                        Sold: _.sumBy(children, `Dates[${i}].Availability.Sold`),
                        Available: _.sumBy(children, `Dates[${i}].Availability.Available`),
                        RoomPrice: _.sumBy(children, 'RoomPrice')
                      }
                      break;
                    default:
                      row[`Date_${i}`] = {
                      }
                      break;
                  }

                }
                return row
              })
              return result
            } else {
              return null
            }
          }
          return group(row?.next || 0, row?.children || rootRows)
        },
        treeColumnName: "Selection"
      },
      columnExtensions: [
        { columnName: 'Selection', width: 300 }
      ],
      scrollbarX: isMobileOnly
    }
  }
  return (<GridSearchTemplate options={gridOptions} onSearchComplete={(data, search) => {
    setSearch(search)
    return true
  }} onSearchChange={onSearchChange} />)
}
